import * as React from 'react';
import './App.css';
import { glossaryTerms } from './glossary/GlossaryService';
import { GlossaryItemComponent } from './glossary/GlossaryItem';
import Heading from './heading/Heading';

class App extends React.Component {

  public render() {

    return (
      <div className="App">

        <Heading text="Pojmovnik" image="pojmovnik"/>

        { glossaryTerms.map(term => 
            <GlossaryItemComponent key={term.id} term={term}></GlossaryItemComponent>
        ) }
       
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx